import { Map } from 'react-loadable'

export const prefetch = () =>
  import('./components/Home')

const HomeModule = Map({
  loader: {
    Module: prefetch
  },
  loading: () => null,
  render: ({ Module }, props) => {
    const Component = Module.default
    return <Component {...props} />
  }
})

export const Home = HomeModule
